import React, { useEffect, useState } from 'react'
import { numberWithCommas } from 'components/spreadsheet/helpers/format'
import { IAchievementsObject } from 'types'
import api from 'helpers/api'
import { useApplicationStore } from 'hooks/application'
import builtProcessesImg from 'assets/images/built-processes.webp'
import createdTablesImg from 'assets/images/created-tables.webp'
import Skeleton from 'components/skeleton'

interface AchievementsProps {
  userId?: string
}

const Achievements: React.FC<AchievementsProps> = ({ userId }) => {
  const { displayErrorMessage } = useApplicationStore()

  const [achievements, setAchievements] = useState<IAchievementsObject>()
  useEffect(() => {
    if (userId) {
      api
        .getAchievements(userId)
        .then((response) => {
          setAchievements(response.data)
        })
        .catch((error) => {
          displayErrorMessage(error)
        })
    } else {
      setAchievements(undefined)
    }
  }, [userId])

  return (
    <div className="mt-5 font-bold w-full border-t border-divider">
      <div className="mt-2.5">Achievements</div>
      <div className="flex flex-row flex-wrap mt-2.5">
        {achievements !== undefined && achievements.createdProcesses !== undefined ? (
          achievements.createdProcesses !== 0 ? (
            <div className="relative inline-block" title={`${achievements.createdProcesses} Documents Created`}>
              <img src={builtProcessesImg} className="h-15 w-15" alt="Documents Created" />
              <div className="absolute text-sm p-0.5 rounded-[30%] bg-light-blue bottom-[-5px] right-[-2px]">
                x{numberWithCommas(achievements.createdProcesses)}
              </div>
            </div>
          ) : (
            <div />
          )
        ) : (
          <Skeleton className="rounded-full w-15 h-15" />
        )}

        {achievements !== undefined && achievements.createdTables !== undefined ? (
          achievements.createdTables !== 0 ? (
            <div className="relative inline-block ml-[15px]" title={`${achievements.createdTables} Tables Created`}>
              <img src={createdTablesImg} className="h-15 w-15" alt="Tables Created" />
              <div className="absolute text-sm p-0.5 rounded-[30%] bg-light-red bottom-[-5px] right-[-2px]">
                x{numberWithCommas(achievements.createdTables)}
              </div>
            </div>
          ) : (
            <div />
          )
        ) : (
          <Skeleton className="rounded-full ml-[15px] w-15 h-15" />
        )}
      </div>
    </div>
  )
}

export default Achievements
